<div provide-parent-form *ngIf="entity">
	<div class="header">{{'YOUTUBE_CHANNEL' | translate}}</div>
	<bb-form-element [form]="form">
		<social-channel-card *ngIf="entity.id" [banner]="entity.remoteBannerImageUrl"
		[logo]="entity.remoteLogoImageUrl" [title]="entity.remotePageTitle"
		[url]="entity.remoteUrl" [authentication]="entity.authExpired"></social-channel-card>
		<div *ngIf="entity.id" class="auth-text">{{ (entity.authExpired ? 'ACCOUNT_NOT_AUTHENTICATED' : 'ACCOUNT_AUTHENTICATED') | translate }}</div>
		<bb-button [disabled]="isDisabled" icon="youtube" (click)="reauthenticateYoutube()">{{ (entity.id ? 'RE_AUTHENTICATE' : 'AUTHENTICATE') | translate }}</bb-button>
		<div class="consent">
			<small [innerHTML]="'YOUTUBE_CONSENT' | translate : { buttonType: (entity.id ? 'RE_AUTHENTICATING' : 'AUTHENTICATING') | translate | lowercase }"></small>
		</div>
		<!-- not authenticated: 427 authenticated: 419-->
	</bb-form-element>

	<hr/>

	<bb-form-element [form]="form" [label]="'CHANNEL_DESCRIPTION' | translate">
		<input [(ngModel)]="entity.name" type="text" name="name" />
	</bb-form-element>	

	<bb-form-element [form]="form" [label]="'YOUTUBE_PLAYLIST_OPTIONAL' | translate" *ngIf="ytPlaylistOptions?.length">
		<bb-entity-selector
			[placeholder]="'Select a playlist (optional)'"
			[options]="ytPlaylistOptions"
			[(ngModel)]="entity.ytPlaylistId"
			name="ytPlaylistId"
		></bb-entity-selector>
	</bb-form-element>	

	<bb-form-element [form]="form" [label]="'YOUTUBE_PRIVACY_SETTING' | translate">
		<bb-select [(ngModel)]="entity.privacy" [options]="youTubePrivacySettings" name="privacy"></bb-select>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'YOUTUBE_CATEGORY' | translate">
		<bb-select [(ngModel)]="entity.categoryId" [options]="youtubeCategories" name="categoryId"></bb-select>
	</bb-form-element>
</div>